module.exports = __webpack_public_path__ + "img/5b87c49.jpg";